import React from "react"

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  rowsPerPage,
  totalRows,
  onRowsPerPageChange,
  siblingCount = 2,
}) {
  // build the sliding window of page numbers
  let start = Math.max(1, currentPage - siblingCount)
  let end = Math.min(totalPages, currentPage + siblingCount)

  if (end - start < siblingCount * 2) {
    start = Math.max(1, end - siblingCount * 2)
    end = Math.min(totalPages, start + siblingCount * 2)
  }

  const pages = []
  for (let p = start; p <= end; p++) pages.push(p)

  return (
    <div className="faxes-pagination">
      {/* Rows Per Page Dropdown */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          marginRight: "6px",
        }}
      >
        <label htmlFor="rowsPerPage" style={{ fontSize: "12px" }}>
          Rows per page:
        </label>
        <select
          id="rowsPerPage"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          style={{
            padding: "4px",
            fontSize: "12px",
            outline: "none",
            border: "1px solid #ccc",
          }}
        >
          {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
            <option key={count} value={count}>
              {count}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <span style={{ fontSize: "12px" }}>Total Pages: {totalPages}</span>|
        <span style={{ fontSize: "12px", marginRight: "12px" }}>
          Total Rows: {totalRows}
        </span>
        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          First
        </button>
        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={`faxes-pagination-button page${
              p === currentPage ? " active" : ""
            }`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}
        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          Last
        </button>
      </div>
    </div>
  )
}
